import axiosX from './axiosX'

export function getSpecTracker(params={}, onSuccess, onFail){
  axiosX.get('services/check/specimen',params,
    (result) => {
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess(result.data.items)
      }
    },
    onFail);
}

export default {
  getSpecTracker
}



// WEBPACK FOOTER //
// ./src/api/apiSpecTracker.js